<div class="dialog-title" class="danger">
  <h2 mat-dialog-title>
    {{ data.title }}
  </h2>
  <sqep-dialog-close-button mat-dialog-close />
</div>
<mat-dialog-content role="dialog">
  <div class="inactivity-message">
    {{ inactivity() }}
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <sqep-button
    buttonCaption="I'm still here!"
    buttonTheme="sqep-button-secondary"
    (buttonClick)="close()"
  />
  <sqep-button
    buttonCaption="Logout"
    buttonTheme="sqep-button-error"
    (buttonClick)="logout()"
  />
</mat-dialog-actions>
